import React, { useState, useRef } from 'react';

const Phishing = () => {
  return null;
};

export default Phishing;
